// Import React and ReactDOM
import React from 'react';
import ReactDOM from 'react-dom';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-React Plugin
import Framework7React from 'framework7-react';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';
import 'framework7/css/framework7.bundle.rtl.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/bootstrap.min.css';
import '../css/fontawesome.css';
import '../css/app.scss';

// Import App Component
import App from '../components/app.jsx';

import {Provider} from 'react-redux';
import reducers from './../reducers';
import {createStore , applyMiddleware} from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import {createLogger} from 'redux-logger';
const middleware = []
if(process.env.NODE_ENV !== 'production')
    middleware.push(createLogger())


const store = createStore(reducers , composeWithDevTools(applyMiddleware(...middleware)))

// Init F7 Vue Plugin
Framework7.use(Framework7React)

// Mount React App


ReactDOM.render(
    <Provider store={store}>
        {React.createElement(App)}
    </Provider>
    , document.getElementById('app'));